<template>
  <div class="products-supply-chain-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner :content="content.bannerInfo" />

    <PageBusinessCol :content="content.businessIntroduction" />

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 供应链流程 -->
    <PageBusinessCol class="bg-[#F6F8FD] ml:pb-7rem" :content="content.supplyProcess" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#272E3B' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '品牌供应链系统'
const description = '一款专为零售品牌制造企业量身定制的智能化供应链电商平台'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/supply-chain/banner.png',
    mobileBanner: '/images/mobile/products/ppgylxt.png'
  },
  businessIntroduction: {
    title: '产品业务介绍',
    description: [
      '和贵科技自主独立研发，高效、可靠的B2B电商下单和供应链管理平台，服务于口味王集团、经销商及二级经销商。',
      '致力于通过其精细化的营销管理功能，提升业务效率，优化用户体验，为财务提供更加精准和透明的财务管理',
      '同时为经销商和二级经销商创造更大的业务价值。'
    ],
    descImage: '/images/pages/products/supply-chain/c.png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#F6F8FD',
    extraTitleClass: 'bg-#F6F8FD w-100%!',
    groups: [
      {
        title: '供应链下单',
        desc: '',
        descList: [
          '实现经销商、二级经销商，从下单到商家发货的订单全流程管理',
        ],
        icon: '/images/pages/products/supply-chain/f-i- (1).png',
        mainImage: '/images/pages/products/supply-chain/f- (1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '优惠活动',
        desc: '',
        descList: [
          '支持商家配置不同优惠活动，向经销商发放优惠券，用于下单减免',
        ],
        icon: '/images/pages/products/supply-chain/f-i- (2).png',
        mainImage: '/images/pages/products/supply-chain/f- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '商品管理',
        desc: '',
        descList: [
          '维护、管理商品价格，上下架',
        ],
        icon: '/images/pages/products/supply-chain/f-i- (3).png',
        mainImage: '/images/pages/products/supply-chain/f- (3).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '库存管理',
        desc: '',
        descList: [
          '提供实时商品库存管理，且商家可自行设置可售库存，下单时自动匹配库存，防超卖',],
        icon: '/images/pages/products/supply-chain/f-i- (4).png',
        mainImage: '/images/pages/products/supply-chain/f- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '电子发票',
        desc: '',
        descList: [
          '基于订单实现自动数电票功能',
        ],
        icon: '/images/pages/products/supply-chain/f-i- (5).png',
        mainImage: '/images/pages/products/supply-chain/f- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '员工管理',
        desc: '',
        descList: [
          '可管理员工账号，并根据实际情况开通对应权限，不同岗位的人员只能访问其权限范围内的功能和数据',
        ],
        icon: '/images/pages/products/supply-chain/f-i- (6).png',
        mainImage: '/images/pages/products/supply-chain/f- (6).png',
        direction: 'copywriting-to-image'
      }, {
        title: '结算分账',
        desc: '',
        descList: [
          '支持依据业务规则与协议，自定义经销商、集团间分账规则，系统精准计算金额，自动分账结算',
        ],
        icon: '/images/pages/products/supply-chain/f-i- (7).png',
        mainImage: '/images/pages/products/supply-chain/f- (7).png',
        direction: 'image-to-copywriting'
      }, {
        title: '财务报表',
        desc: '',
        descList: [
          '为各级商家提供全面、准确的数据报表，助力企业管理者洞察经营状况，实现财务风险预警与管控。',
        ],
        icon: '/images/pages/products/supply-chain/f-i- (8).png',
        mainImage: '/images/pages/products/supply-chain/f- (8).png',
        direction: 'copywriting-to-image'
      },
    ]
  },
  supplyProcess: {
    title: '供应链流程',
    description: [
      '二级经销商下单、一级经销商与企业分账功能无缝衔接，实现供应链',
      '上下游信息共享与协同作业。'
    ],
    descImage: '/images/pages/products/supply-chain/s-p- (1).png'
  },
  advantage: {
    title: '产品优势',
    desc: '专业团队技术能力更强，运维有保障',
    background: '/images/pages/products/supply-chain/b-b.png',
    list: [
      {

        briefBack: '/images/pages/products/supply-chain/b- (3).png',
      },
      {
        briefBack: '/images/pages/products/supply-chain/b- (2).png',
      },
      {
        briefBack: '/images/pages/products/supply-chain/s-c- (1).png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-supply-chain-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .supply-chain-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/supply-chain/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/supply-chain/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.supply-chain-product-advantage {
  background-image: url("/images/pages/products/supply-chain/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
